module.exports = __webpack_public_path__ + "img/cross.ad3be944.png";